import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=55453854&"
import script from "./tenant.vue?vue&type=script&lang=ts&"
export * from "./tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports